import {
    differenceInCalendarDays,
    differenceInCalendarMonths,
    differenceInCalendarQuarters,
    differenceInCalendarWeeks,
    differenceInCalendarYears,
    differenceInDays,
    differenceInHours,
    differenceInMilliseconds,
    differenceInMinutes,
    differenceInMonths,
    differenceInQuarters,
    differenceInSeconds,
    differenceInWeeks,
    differenceInYears,
} from 'date-fns'

import { Timezone } from '@/entities'

import { TimeUnit } from './types'
import { utcToZonedTime } from './utcToZonedTime'

//
// Calendar = Takes difference without time delta ie month difference between 31.5 and 01.06 is one
// while if calendar is set to false the time span is considered so in this case would result in 0
//
export const dateDifference = (
    futureDate: Date,
    pastDate: Date,
    unit: TimeUnit,
    { calendar = true, timezone }: { calendar?: boolean; timezone?: Timezone } = {}
) => {
    const isCalendarUnit = [
        'day',
        'days',
        'week',
        'weeks',
        'month',
        'months',
        'quarter',
        'quarters',
        'year',
        'years',
    ].includes(unit)
    const useTimezone = calendar && isCalendarUnit && timezone
    const future = useTimezone ? utcToZonedTime(futureDate, timezone) : futureDate
    const past = useTimezone ? utcToZonedTime(pastDate, timezone) : pastDate

    switch (unit) {
        case 'millisecond':
        case 'milliseconds':
            return differenceInMilliseconds(future, past)
        case 'second':
        case 'seconds':
            return differenceInSeconds(future, past)
        case 'minute':
        case 'minutes':
            return differenceInMinutes(future, past)
        case 'hour':
        case 'hours':
            return differenceInHours(future, past)
        case 'day':
        case 'days':
            return calendar ? differenceInCalendarDays(future, past) : differenceInDays(future, past)
        case 'week':
        case 'weeks':
            return calendar ? differenceInCalendarWeeks(future, past) : differenceInWeeks(future, past)
        case 'month':
        case 'months':
            return calendar ? differenceInCalendarMonths(future, past) : differenceInMonths(future, past)
        case 'quarter':
        case 'quarters':
            return calendar ? differenceInCalendarQuarters(future, past) : differenceInQuarters(future, past)
        case 'year':
        case 'years':
            return calendar ? differenceInCalendarYears(future, past) : differenceInYears(future, past)
    }
}
